module.exports = __webpack_public_path__ + "assets/visa_2x.ec1d8301.svg";